(function() {
    'use strict';

    angular
        .module('jobseeker-portal')
        .directive('tessShareThis', tessShareThis);

    function tessShareThis($timeout) {
        return {
            restrict: 'A',
            link: function() {
                stButtons.locateElements();
                $timeout(function() {
                   console.log(1);
                   console.log(2);
                });
            }
        };
    }
})();